module.exports = __webpack_public_path__ + "static/media/WD.a50d6301.png";